var App = App || {};
(function() {
	// переклади з window.WS_I18N (inc/i18n.phtml); без словника — ключ як є
	let t = function (key) { return (window.WS_I18N && window.WS_I18N[key]) || key; };

	let self = App.modal = {

		overlay_id: 'modal_overlay',
		modal_id: 'modal',

		current_url: '',
		is_loading: false,

		last_opts: null,

		defaults: {
			width: null,
			fullscreen_threshold: 480,
			cache: false,
			skip_auto_width: false,
			load_type: ''
		},

		_escapeAttr: function (s) {
			return String(s).replace(/'/g, "\\'");
		},

		_normalizeOpts: function (options) {
			let opts = $.extend({}, self.defaults, options || {});

			if (opts.width !== null && opts.width !== undefined && opts.width !== false && opts.width !== '') {
				let w = parseFloat(opts.width);
				opts.width = (!isNaN(w) && w > 0) ? w : null;
			} else {
				opts.width = null;
			}

			if (opts.fullscreen_threshold !== null && opts.fullscreen_threshold !== undefined && opts.fullscreen_threshold !== false && opts.fullscreen_threshold !== '') {
				let t = parseFloat(opts.fullscreen_threshold);
				opts.fullscreen_threshold = (!isNaN(t) && t > 0) ? t : null;
			} else {
				opts.fullscreen_threshold = null;
			}

			opts.cache = !!opts.cache;
			opts.skip_auto_width = !!opts.skip_auto_width;

			return opts;
		},

		_getOverlay: function () {
			return $('#' + self._escapeAttr(self.overlay_id));
		},

		_getModal: function () {
			return $('#' + self._escapeAttr(self.modal_id));
		},

		_setInnerHtml: function (html) {
			let $md = self._getModal();
			if (!$md.length) return;

			let $inner = $md.find('.modal__inner').first();
			let $close = $inner.find('.modal__close').first().detach();

			$inner.html(html);
			$inner.prepend($close);
		},

		_isYouTubeUrl: function (url) {
			if (!url) return false;
			url = String(url);
			return /(^|\/\/)(www\.)?(youtube\.com|youtu\.be)\//i.test(url);
		},

		_getYouTubeId: function (url) {
			if (!url) return null;
			url = String(url).trim();

			let m = url.match(/youtu\.be\/([a-zA-Z0-9_-]{6,})/i);
			if (m && m[1]) return m[1];

			m = url.match(/[?&]v=([a-zA-Z0-9_-]{6,})/i);
			if (m && m[1]) return m[1];

			m = url.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{6,})/i);
			if (m && m[1]) return m[1];

			m = url.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{6,})/i);
			if (m && m[1]) return m[1];

			return null;
		},

		_renderYouTubePlayer: function (url, opts) {
			let id = self._getYouTubeId(url);
			if (!id) {
				self._setInnerHtml('<div class="modal__loading">Невірне YouTube-посилання.</div>');
				self._afterRender(opts);
				return;
			}

			let $md = self._getModal();
			if ($md.length && !$md.hasClass('modal-fullscreen')) {
				let vw80 = Math.floor($(window).width() * 0.8);
				let w = (opts && opts.width) ? parseFloat(opts.width) : null;

				if (!w || isNaN(w) || w <= 0) w = 960;
				if (vw80 > 0 && w > vw80) w = vw80;
				if (w < 640) w = Math.min(640, vw80 || 640);

				$md[0].style.setProperty('--modal-w', w + 'px');
			}

			let src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';

			let html =
				'<div class="modal__video">' +
				'<div class="modal__ratio">' +
				'<iframe ' +
				'src="' + src + '" ' +
				'frameborder="0" ' +
				'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ' +
				'allowfullscreen>' +
				'</iframe>' +
				'</div>' +
				'</div>';

			self._setInnerHtml(html);
			self._afterRender(opts);
		},

		_ensureDom: function () {
			let $ov = self._getOverlay();
			let $md = self._getModal();

			if (!$ov.length) {
				$ov = $('<div/>', { id: self.overlay_id }).appendTo('body');
			}

			if (!$md.length) {
				$md = $('<div/>', { id: self.modal_id })
					.append(
						$('<div/>', { class: 'modal__inner' })
							.append($('<button/>', { type: 'button', class: 'modal__close', 'aria-label': t('Закрыть') }).html('✕'))
					)
					.appendTo('body');
			}

			return { $overlay: $ov, $modal: $md, $inner: $md.find('.modal__inner').first() };
		},

		_setLoading: function (on) {
			let $md = self._getModal();
			if (!$md.length) return;

			if (on) {
				$md.addClass('modal-loading');
				if (!$md.find('.modal__loading').length) {
					self._setInnerHtml('<div class="modal__loading" role="status" aria-busy="true"></div>'); // без тексту: спінер у CSS, щоб не тягнути переклади в JS
				}
			} else {
				$md.removeClass('modal-loading');
			}
		},

		_applyAutoWidth: function (opts) {
			let $md = self._getModal();
			if (!$md.length) return;

			if ($md.hasClass('modal-fullscreen')) return;
			if (opts && opts.width) return;
			if (opts && opts.skip_auto_width) return;

			let $inner = $md.find('.modal__inner').first();
			if (!$inner.length) return;

			let vw = Math.floor($(window).width() * 0.8);

			$md[0].style.removeProperty('--modal-w');

			requestAnimationFrame(function () {
				let w = $inner[0].scrollWidth || 0;
				if (w < 160) w = 160;
				if (vw > 0 && w > vw) w = vw;

				$md[0].style.setProperty('--modal-w', w + 'px');
			});
		},

		_updateFullscreenCentering: function () {
			let $md = self._getModal();
			if (!$md.length) return;

			if (!$md.hasClass('modal-fullscreen')) {
				$md.removeClass('modal-fullscreen-centered');
				return;
			}

			let $inner = $md.find('.modal__inner').first();
			if (!$inner.length) return;

			let viewportH = $(window).height();
			let innerH = $inner[0].scrollHeight;

			if (innerH <= viewportH) {
				$md.addClass('modal-fullscreen-centered');
			} else {
				$md.removeClass('modal-fullscreen-centered');
			}
		},

		_afterRender: function (opts) {
			self._applyAutoWidth(opts || {});
			self._updateFullscreenCentering();
		},

		_applySizeMode: function (opts) {
			let $md = self._getModal();
			if (!$md.length) return;

			$md.removeClass('modal-fullscreen modal-fullscreen-centered modal-loading');
			$md[0].style.removeProperty('--modal-w');

			let thr = opts.fullscreen_threshold;
			let forceFullscreen = false;

			if (thr !== null && thr !== undefined && thr !== false) {
				thr = parseFloat(thr);
				if (!isNaN(thr) && thr > 0) {
					let vw = $(window).width();
					if (vw <= thr) forceFullscreen = true;
				}
			}

			if (forceFullscreen) {
				$md.addClass('modal-fullscreen');
			} else {
				let w = opts.width;
				if (w !== null && w !== undefined && w !== false) {
					w = parseFloat(w);
					if (!isNaN(w) && w > 0) {
						$md[0].style.setProperty('--modal-w', w + 'px');
					}
				}
			}

			self._afterRender(opts);
		},

		_load: function (url, opts) {
			self.is_loading = true;
			self.current_url = url;

			// спершу режим розміру (він скидає класи, зокрема modal-loading), потім стан завантаження
			self._applySizeMode(opts);
			self._setLoading(true);

			if (self._isYouTubeUrl(url)) {
				self.is_loading = false;
				self._setLoading(false);
				let ytOpts = $.extend({}, opts, { skip_auto_width: true });
				self._renderYouTubePlayer(url, ytOpts);
				return;
			}

			if (opts && opts.load_type === 'image') {
				let img = new Image();
				// спінер лишається, поки картинка реально не завантажиться
				img.onload = function() {
					self.is_loading = false;
					self._setLoading(false);
					self._setInnerHtml('<div class="modal__image"><img src="' + url + '"></div>');
					self._afterRender(opts);
				};
				img.onerror = function() {
					self.is_loading = false;
					self._setLoading(false);
					self._setInnerHtml('<div class="modal__message">' + t('Не удалось загрузить изображение') + '</div>');
					self._afterRender(opts);
				};
				img.src = url;
				return;
			}

			let headers = {};
			if (opts && opts.load_type) headers['X-Load-Type'] = String(opts.load_type);

			$.ajax({
				url: url,
				method: 'GET',
				cache: !!opts.cache,
				dataType: 'html',
				headers: headers
			}).done(function (html) {
				if (self.current_url !== url) return;

				self._setInnerHtml(html);
				self._afterRender(opts);

			}).fail(function () {
				if (self.current_url !== url) return;

				self._setInnerHtml('<div class="modal__message">' + t('Не удалось загрузить содержимое') + '</div>');
				self._afterRender(opts);

			}).always(function () {
				if (self.current_url !== url) return;
				self.is_loading = false;
				self._setLoading(false);
				self._afterRender(opts);
			});
		},

		_lockScroll: function () {
			const body = document.body;
			const html = document.documentElement;

			if (body.classList.contains('modal-open')) return;

			const hasScroll = html.scrollHeight > window.innerHeight;

			if (!hasScroll) return;

			html.style.scrollbarGutter = 'stable';
			body.classList.add('modal-open');
		},

		_unlockScroll: function () {
			const body = document.body;
			const html = document.documentElement;

			html.style.scrollbarGutter = '';
			body.classList.remove('modal-open');
		},

		show: function (url, options) {
			if (!url) return;

			let opts = self._normalizeOpts(options);
			self.last_opts = opts;

			self._ensureDom();
			self._lockScroll();
			self._load(url, opts);
		},

		hide: function () {
			let $ov = self._getOverlay();
			let $md = self._getModal();

			if ($ov.length) $ov.remove();
			if ($md.length) $md.remove();

			self._unlockScroll();

			self.current_url = '';
			self.is_loading = false;
			self.last_opts = null;
		},

		init: function () {
			$(document).off('click.appmodal').on('click.appmodal', '[data-modal="true"]', function (e) {
				let $t = $(this);
				let href = $t.attr('data-href');
				if (!href) return;

				e.preventDefault();
				e.stopPropagation();

				let w = $t.attr('data-modal-width');
				let thr = $t.attr('data-modal-fullscreen-threshold');

				let o = { load_type: 'modal' };
				if (w !== undefined && w !== null && w !== '') o.width = w;
				if (thr !== undefined && thr !== null && thr !== '') o.fullscreen_threshold = thr;

				self.show(href, o);
			});

			$(document).off('click.appmodal-close').on('click.appmodal-close', '#' + self.overlay_id, function (e) {
				e.preventDefault();
				e.stopPropagation();
				self.hide();
			});

			$(document).off('click.appmodal-closebtn').on('click.appmodal-closebtn', '#' + self.modal_id + ' .modal__close', function (e) {
				e.preventDefault();
				e.stopPropagation();
				self.hide();
			});

			$(document).off('keydown.appmodal').on('keydown.appmodal', function (e) {
				if (e.key === 'Escape') self.hide();
			});

			$(window).off('resize.appmodal').on('resize.appmodal', function () {
				let $md = self._getModal();
				if (!$md.length) return;

				if (self.last_opts) {
					self._applySizeMode(self.last_opts);
				} else {
					self._updateFullscreenCentering();
				}
			});
		},

		onload: function () {
			self.init();
		}
	}
})();
$(App.modal.onload);
